import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { ApiSaveDataOffer } from '../../../api/services/savedataoffer/savedataoffer'
import { ApiSaveDataOfferPostData } from '../../../api/services/savedataoffer/savedataoffer.types'
import { selectUser } from '../../../redux/slices/UserSlice/UserSlice.selectors'
import { useAppSelector } from '../../reduxHooks'
const useApiSaveDataOffer = () => {
  const { serverUrl: serverPath, token: userToken } = useAppSelector(selectUser)

  const { t } = useTranslation()

  const saveDataOffer = useCallback(
    async (data: Omit<ApiSaveDataOfferPostData, 'userToken'>) => {
      const response = await ApiSaveDataOffer({
        serverPath,
        data: {
          userToken,
          ...data
        }
      })
      if (!response.data.ok) {
        toast.error(t('errors.an_error_has_ocurred'))
        return response
      }
      toast.success(t('alerts.data_saved'))
      return response
    },
    [serverPath, t, userToken]
  )

  return {
    saveDataOffer
  }
}
export default useApiSaveDataOffer
